import {
    defaultIpgConfigByKey,
    type MerchantConfig,
    ValorIpgSystemIdKey,
} from '@pillar-portal/api-types';
import type { CredentialFieldDefaults } from '../../credential-defaults';

export function resolveValorCredentialDefaults(
    merchantConfig: MerchantConfig | undefined
): CredentialFieldDefaults {
    const effectiveValorConfig =
        merchantConfig?.ipg[ValorIpgSystemIdKey] ??
        defaultIpgConfigByKey[ValorIpgSystemIdKey];
    return {
        domain: effectiveValorConfig.default_api_url,
        channel: effectiveValorConfig.default_channel,
    };
}
